/* eslint-disable no-mixed-spaces-and-tabs */
// Packages
import React from 'react'

import { Row, Col } from 'antd'
import jobExperienceIcon from '../../public/img/JobExperience.svg'
import WorkExperienceIcon from '../../public/img/WorkExperience.svg'
import EducationIcon from '../../public/img/Education.svg'
import CertificateIcon from '../../public/img/Certificate.svg'
import LicenseIcon from '../../public/img/License.svg'
import AvailabilityIcon from '../../public/img/Availability.svg'
import LanguageProficiency from '../../public/img/LanguageProficiency.svg'
import {
	Applicant,
	ApplicantExperiences as ApplicantExperiencesProps,
	ApplicantOccupationQuestionAnswers as ApplicantOccupationQuestionAnswersProps,
} from './ProfileDownload'

// Job Experience
const JobKnowledge = ({
	ApplicantOccupationQuestionAnswers,
}: {
  ApplicantOccupationQuestionAnswers: ApplicantOccupationQuestionAnswersProps[];
}) => {

	// Filter out Certificates && Licenses
	const withoutCertsAndLicenses = ApplicantOccupationQuestionAnswers.filter(
		(ele) => ele.OccupationQuestionAnswer.certLicenseName === null
	)

	const distinctOccupation = [
		...new Set(
			withoutCertsAndLicenses.map(
				({ OccupationQuestionAnswer }) =>
					OccupationQuestionAnswer.Occupation.name
			)
		),
	]

	const distinctOccupationWithAnswer = distinctOccupation.map((occupation) => {
		return {
			Occupation: occupation,
			answers: withoutCertsAndLicenses
				.filter(
					({ OccupationQuestionAnswer }) =>
						OccupationQuestionAnswer.Occupation.name === occupation
				)
				.map(({ OccupationQuestionAnswer }) => OccupationQuestionAnswer),
		}
	})

	return (
		<>
			{distinctOccupationWithAnswer.length ? (
				<>
					<Row align='middle'>
						<img
							src={jobExperienceIcon}
							style={{ width: 30, height: 30 }}
							alt=""
						/>
						<h4 style={{ color: '#9b9b9b', marginTop: 5, marginLeft: 5 }}>
              Job Experience
						</h4>
					</Row>
					{distinctOccupationWithAnswer.map((dowa, index1) => {
						const distinctPrependText = [
							...new Set(
								dowa.answers
									.map((ele) => ele.prependText)
									.filter((ele) => ele !== null)
							),
						]

						return (
							<div key={index1} style={{ marginBottom: '2rem' }}>
								<Row>
									<Col>
										<h3>{dowa.Occupation}</h3>
									</Col>
								</Row>
								{dowa.answers
									.filter((ele) => ele.prependText === null)
									.map((ele, index2) => {
										return (
											<Row key={index2}>
												<Col>
													<ul
														style={{
															margin: 0,
															padding: 0,
															marginInlineStart: '1.33em',
														}}
													>
														<li>{ele.answerText}</li>
													</ul>
												</Col>
											</Row>
										)
									})}
								{distinctPrependText.map((text, index3) => {
									const correspondingAnswers = dowa.answers.filter(
										(ele) => ele.prependText === text
									)
									return (
										<>
											<Row key={index3} style={{ marginTop: '8px' }}>
												<Col>
													<h4>{text}</h4>
												</Col>
											</Row>
											<Row>
												<Col>
													<ul>
														{correspondingAnswers.map((ele, index4) => {
															return (
																<li key={index4}>
																	{ele.answerText.replace(ele.prependText, '')}
																</li>
															)
														})}
													</ul>
												</Col>
											</Row>
										</>
									)
								})}
							</div>
						)
					})}
				</>
			) : null}
		</>
	)
}

// Work Experience
const WorkExperience = ({
	ApplicantExperiences,
}: {
  ApplicantExperiences: ApplicantExperiencesProps[];
}) => {

	return (
		<>
			{ApplicantExperiences.length ? (
				<div style={{ marginBottom: '2rem' }}>
					<Row align='middle'>
						<img
							src={WorkExperienceIcon}
							style={{ width: 30, height: 30 }}
							alt=""
						/>
						<h4 style={{ color: '#9b9b9b', marginTop: 5, marginLeft: 5 }}>
              Work Experience
						</h4>
					</Row>
					{ApplicantExperiences.map((experience, index) => {
						const { companyName, experienceYears, jobTitle } = experience
						return (
							<div key={index}>
								<Row>
									<Col>
										<h3 style={{ marginBottom: 0 }}>
											{jobTitle}
											<span
												style={{
													color: '#9B9B9B',
													fontWeight: 'normal',
													fontSize: 'smaller',
												}}
											>
												{companyName === null ? '' : ` at ${companyName}`}
											</span>
											<span
												style={{
													color: '#9B9B9B',
													fontWeight: 'normal',
													fontSize: 'smaller',
												}}
											>
												{experienceYears !== null && experienceYears !== 0
													? ` (${
														experienceYears === -1
															? 'Less than one year'
															: experienceYears !== 1
																? `${experienceYears} years`
																: '1 year'
													}) `
													: ''}
											</span>
										</h3>
									</Col>
								</Row>
							</div>
						)
					})}
				</div>
			) : null}
		</>
	)
}

// Education
const Education = ({ applicant }: { applicant: Applicant }) => {
	const { Enum_EducationLevel: educationLevel, education } = applicant

	const getEducation = () => {
		if (educationLevel !== null && educationLevel.display !== 'Others') {
			return educationLevel.display
		} else return education
	}
	return (
		<>
			{education || educationLevel !== null ? (
				<>
					<Row align='middle'>
						<img src={EducationIcon} style={{ width: 30, height: 30 }} alt="" />
						<h4 style={{ color: '#9b9b9b', marginTop: 5, marginLeft: 5 }}>
              Education
						</h4>
					</Row>
					<Row style={{ marginBottom: '2rem' }}>
						<Col>
							{/* <h3>{education}</h3> */}
							<h3>{getEducation()}</h3>
						</Col>
					</Row>
				</>
			) : null}
		</>
	)
}

// Certificate
const Certificate = ({
	ApplicantOccupationQuestionAnswers,
}: {
  ApplicantOccupationQuestionAnswers: ApplicantOccupationQuestionAnswersProps[];
}) => {

	const certificates = ApplicantOccupationQuestionAnswers.filter(
		({ OccupationQuestionAnswer }) =>
			OccupationQuestionAnswer.answerText
				.toLowerCase()
				.includes('certificate') ||
      OccupationQuestionAnswer.answerText
      	.toLowerCase()
      	.includes('certification')
	).map(({ OccupationQuestionAnswer }) =>
		OccupationQuestionAnswer.answerText.replace('I have ', '')
	)

	const distinct = [...new Set(certificates)] // There are similar Certificates across Occupations

	return (
		<>
			{certificates.length ? (
				<div style={{ marginBottom: '2rem' }}>
					<Row align='middle'>
						<img
							src={CertificateIcon}
							style={{ width: 30, height: 30 }}
							alt=""
						/>
						<h4 style={{ color: '#9b9b9b', marginTop: 5, marginLeft: 5 }}>
            Certificate
						</h4>
					</Row>
					{distinct.map((cert, index) => {
						return (
							<Row key={index}>
								<Col>
									<ul
										style={{
											margin: 0,
											padding: 0,
											marginInlineStart: '1.33em',
										}}
									>
										<li>
											<h3>{cert}</h3>
										</li>
									</ul>
								</Col>
							</Row>
						)
					})}
				</div>
			) : null}
		</>
	)
}

// License
const License = ({
	ApplicantOccupationQuestionAnswers,
}: {
  ApplicantOccupationQuestionAnswers: ApplicantOccupationQuestionAnswersProps[];
}) => {

	const licenses = ApplicantOccupationQuestionAnswers.filter(
		({ OccupationQuestionAnswer }) =>
			OccupationQuestionAnswer.answerText.toLowerCase().includes('license')
	).map(({ OccupationQuestionAnswer }) => {
		if (OccupationQuestionAnswer.answerText.toLowerCase().includes('driving')) {
			return OccupationQuestionAnswer.answerText.replace('I have a valid ', '')
		}
		if (
			OccupationQuestionAnswer.answerText.toLowerCase().includes('forklift')
		) {
			return 'Forklift License'
		}
		return null
	})

	const distinctLicenses = [...new Set(licenses)]

	return (
		<>
			{licenses.length ? (
				<div style={{ marginBottom: '2rem' }}>
					<Row align='middle'>
						<img src={LicenseIcon} style={{ width: 30, height: 30 }} alt="" />
						<h4 style={{ color: '#9b9b9b', marginTop: 5, marginLeft: 5 }}>
              License
						</h4>
					</Row>
					{distinctLicenses.map((cert, index) => {
						return (
							<Row key={index}>
								<Col>
									<ul
										style={{
											margin: 0,
											padding: 0,
											marginInlineStart: '1.33em',
										}}
									>
										<li>
											<h3>{cert}</h3>
										</li>
									</ul>
								</Col>
							</Row>
						)
					})}
				</div>
			) : null}
		</>
	)
}

// English Proficiency
const EnglishProficiency = ({
	languageSkills,
}: {
  languageSkills: string;
}): JSX.Element => {
	if (languageSkills === null) {
		return <></>
	}

	const engArr =
    typeof languageSkills === 'string'
    	? languageSkills
    		.trim()
    		.split(',')
    	// eslint-disable-next-line
          .filter((x) => {
    			if (x.includes('English')) {
    				return x
    			}
    		})
    	: [] // Remove Empty
	const finalEngArr = engArr.map((eng) => {
		return eng.replace(/(English)+|\s+/g, '')
	})

	return (
		<>
			{finalEngArr.length ? (
				<div style={{ marginBottom: '2rem' }}>
					<Row align='middle'>
						<img
							src={LanguageProficiency}
							style={{ width: 30, height: 30 }}
							alt=""
						/>
						<h4 style={{ color: '#9b9b9b', marginTop: 5, marginLeft: 5 }}>
              Language Proficiency
						</h4>
					</Row>
					<Row>
						<Col>
							<ul style={{ margin: 0, padding: 0 }}>
								<h3>English</h3>
							</ul>
						</Col>
					</Row>
					<Row>
						{finalEngArr.map((eng, index) => {
							return (
								<Col key={index}>
									<h4>
										{eng}
										{index !== finalEngArr.length - 1 ? ',' : ''}&nbsp;
									</h4>
								</Col>
							)
						})}
					</Row>
				</div>
			) : null}
		</>
	)
}

// Mandarin Proficiency
const MandarinProficiency = ({
	languageSkills,
}: {
  languageSkills: string;
}): JSX.Element => {
	if (languageSkills === null) {
		return <></>
	}

	const mandarinarr =
    typeof languageSkills === 'string'
    	? languageSkills
    		.trim()
    		.split(',')
    	// eslint-disable-next-line
          .filter((x) => {
    			if (x.includes('Mandarin')) {
    				return x
    			}
    		})
    	: [] // Remove Empty
	const finalMandarinArr = mandarinarr.map((eng) => {
		return eng.replace(/(Mandarin)+|\s+/g, '')
	})

	return (
		<>
			{finalMandarinArr.length ? (
				<div style={{ marginBottom: '2rem' }}>
					<Row>
						<Col>
							<h3>Mandarin</h3>
						</Col>
					</Row>
					<Row>
						{finalMandarinArr.map((eng, index) => {
							return (
								<Col key={index}>
									<h4>
										{eng}
										{index !== finalMandarinArr.length - 1 ? ',' : ''}&nbsp;
									</h4>
								</Col>
							)
						})}
					</Row>
				</div>
			) : null}
		</>
	)
}

// Malay Proficiency
const MalayProficiency = ({
	languageSkills,
}: {
  languageSkills: string;
}): JSX.Element => {
	// const { t } = useTranslation()

	if (languageSkills === null) {
		return <></>
	}

	const malayarr =
    typeof languageSkills === 'string'
    	? languageSkills
    		.trim()
    		.split(',')
    	// eslint-disable-next-line
          .filter((x) => {
    			if (x.includes('Malay')) {
    				return x
    			}
    		})
    	: [] // Remove Empty
	const finalMalayArr = malayarr.map((eng) => {
		return eng.replace(/(Malay)+|\s+/g, '')
	})

	return (
		<>
			{finalMalayArr.length ? (
				<div style={{ marginBottom: '2rem' }}>
					<Row>
						<Col>
							<h3>Malay</h3>
						</Col>
					</Row>
					<Row>
						{finalMalayArr.map((eng, index) => {
							return (
								<Col key={index}>
									<h4>
										{eng}
										{index !== finalMalayArr.length - 1 ? ',' : ''}&nbsp;
									</h4>
								</Col>
							)
						})}
					</Row>
				</div>
			) : null}
		</>
	)
}

// Tamil Proficiency
const TamilProficiency = ({
	languageSkills,
}: {
  languageSkills: string;
}): JSX.Element => {
	// const { t } = useTranslation()

	if (languageSkills === null) {
		return <></>
	}

	const tamilarr =
    typeof languageSkills === 'string' ?
    	languageSkills
    	.trim()
    	.split(',')
    	// eslint-disable-next-line
      .filter((x) => {
    		if (x.includes('Tamil')) {
    			return x
    		}
    	}) :[]// Remove Empty
	const finalTamilArr = tamilarr.map((eng) => {
		return eng.replace(/(Tamil)+|\s+/g, '')
	})

	return (
		<>
			{finalTamilArr.length ? (
				<div style={{ marginBottom: '2rem' }}>
					<Row>
						<Col>
							<h3>Tamil</h3>
						</Col>
					</Row>
					<Row>
						{finalTamilArr.map((eng, index) => {
							return (
								<Col key={index}>
									<h4>
										{eng}
										{index !== finalTamilArr.length - 1 ? ',' : ''}&nbsp;
									</h4>
								</Col>
							)
						})}
					</Row>
				</div>
			) : null}
		</>
	)
}

// Availability
const Availability = ({ isAvailable }: { isAvailable: boolean }) => {
	return (
		<>
			{isAvailable ? (
				<div style={{ marginBottom: '2rem' }}>
					<Row align='middle'>
						<img
							src={AvailabilityIcon}
							style={{ width: 30, height: 30 }}
							alt=""
						/>
						<h4 style={{ color: '#9b9b9b', marginTop: 5, marginLeft: 5 }}>
              Availability
						</h4>
					</Row>
					<Row>
						<Col>
							<h3>I can Start Immediately</h3>
						</Col>
					</Row>
				</div>
			) : null}
		</>
	)
}

type Props = {
  applicant: Applicant;
};
const ProfileDetails = ({ applicant }: Props) => {
	const {
		ApplicantOccupationQuestionAnswers,
		ApplicantExperiences,
		languageSkills,
		isAvailable,
	} = applicant
	return (
		<>
			<JobKnowledge
				ApplicantOccupationQuestionAnswers={ApplicantOccupationQuestionAnswers}
			/>
			<WorkExperience ApplicantExperiences={ApplicantExperiences} />
			<Education applicant={applicant} />
			<Certificate
				ApplicantOccupationQuestionAnswers={ApplicantOccupationQuestionAnswers}
			/>
			<License
				ApplicantOccupationQuestionAnswers={ApplicantOccupationQuestionAnswers}
			/>
			<EnglishProficiency languageSkills={languageSkills} />
			<MandarinProficiency languageSkills={languageSkills} />
			<MalayProficiency languageSkills={languageSkills} />
			<TamilProficiency languageSkills={languageSkills} />
			<Availability isAvailable={isAvailable} />
		</>
	)
}

export default ProfileDetails
